<template>
  <div class="proceed">
    <Sticky>
      <Search v-model="value" :placeholder="$t('option.proceed.search')">
        <div class="icon" slot="left-icon">
          <img :src="search" alt />
        </div>
      </Search>
    </Sticky>

    <div class="con">
      <CheckboxGroup v-model="selects">
        <div
          class="list"
          v-for="item in showList"
          v-bind:key="item.deviceUniqueId"
          @click="toggleSelect(item.deviceUniqueId)"
        >
          <Checkbox checked-color="#00CCBF" :name="item.deviceUniqueId">
            {{ item.deviceName }}
          </Checkbox>
          <div class="qrcode">
            <img :src="qrcode" alt v-if="item.vrcode" />
          </div>
        </div>
      </CheckboxGroup>
    </div>
    <div class="button">
      <CheckboxGroup v-model="selectAll">
        <Checkbox checked-color="#00CCBF" @click="checkAll" name="true">
          {{ $t('option.proceed.select.all') }}
        </Checkbox>
      </CheckboxGroup>
      <div class="right">
        <span>
          {{ $t('option.proceed.selected') }}
          <strong>{{ selects.length }}</strong>
          {{ $t('option.proceed.selected.end') }}
        </span>
        <div class="btn">
          <Button color="#00CCBF" @click="submit" block>
            {{ $t('common.proceed') }}
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Button, Toast, Notify, Search, Checkbox, CheckboxGroup, Sticky } from 'vant';
import qrcode from '@/assets/icon/qrcode.svg';
import api from '@/services/api';
import search from '@/assets/icon/search.svg';
export default {
  components: {
    Button,
    Search,
    Checkbox,
    CheckboxGroup,
    Sticky,
  },
  data() {
    return {
      search,
      loading: true,
      spin: true,
      list: [],
      devices: [],
      selects: [],
      value: '',
      qrcode,
    };
  },
  computed: {
    select() {
      return this.$route.params.select;
    },
    info() {
      return this.$route.params.info;
    },
    url() {
      return this.$route.path;
    },
    historySelect() {
      return window.history.state && window.history.state.select;
    },
    historyInfo() {
      return window.history.state && window.history.state.info;
    },
    id() {
      return this.$route.params.id;
    },
    selectAll() {
      return [this.selects.length === this.devices.length && this.selects.length > 0 ? 'true' : 'false'];
    },
    showList() {
      const regxp = new RegExp(this.value);
      return this.devices.filter(item => regxp.test(item.deviceName));
    },
  },
  methods: {
    initData() {
      api
        .devices({
          reqPageNum: 1,
          maxResults: 10000,
          deviceTypeId: -1,
          deviceModelId: -1,
          status: 1,
          typeCodeList: ['AccessControl'],
        })
        .then(response => {
          const [success, res] = response;
          if (success) {
            this.devices = res.data;
          }
        });
    },
    initState() {
      if (this.select) {
        window.history.replaceState(
          {
            select: this.select,
            info: this.info,
          },
          this.url
        );
      }
    },
    submit() {
      if (this.info) {
        this.$router.push({
          name: 'visitorUserApply',
          params: { info: this.historyInfo, select: this.selects },
        });
        return;
      }
      if (!this.auth()) return;
      Toast.loading({
        duration: 0,
        forbidClick: true,
        message: this.$t('empty.loading') + '...',
      });
      api
        .review({
          uniqueIds: this.historySelect.join(','),
          remark: null,
          verifyStatus: 1,
          deviceIds: this.selects.join(','),
        })
        .then(res => {
          Toast.clear();
          const [success] = res;
          if (success) {
            this.$router.push({ name: 'visitorOptionResult' });
          }
        });
    },
    auth() {
      if (!this.historySelect) {
        Notify({
          type: 'warning',
          message: this.$t('option.reject.select.tips'),
        });
        return false;
      }

      if (!this.devices.length === 0) {
        Notify({
          type: 'warning',
          message: this.$t('option.proceed.devices.tips'),
        });
        return false;
      }

      return true;
    },
    toggleSelect(id) {
      if (this.selects.includes(id)) {
        const list = this.selects.filter(item => item !== id);
        this.selects = [...list];
      } else {
        this.selects.push(id);
      }
    },
    checkAll() {
      if (this.selects.length === this.devices.length) {
        this.selects = [];
      } else {
        this.selects = this.devices.map(item => item.deviceUniqueId);
      }
    },
  },
  mounted() {
    this.initState();
    this.initData();
  },
};
</script>

<style lang="less" scoped>
.proceed {
  .van-search {
    padding: 16px 30px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.015);
  }
  .van-field__left-icon {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .icon {
    width: 40px;
    height: 40px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .con {
    margin-top: 16px;
    background-color: white;

    .list {
      height: 90px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 30px;
      font-size: 32px;
      color: #3d424d;
      letter-spacing: 0;
      line-height: 38px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.015);

      .qrcode {
        width: 60px;
        height: 60px;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  .button {
    position: fixed;
    height: 98px;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: white;
    padding: 0 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    font-size: 24px;
    color: #5d6067;
    letter-spacing: 0;
    line-height: 28px;

    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;

      strong {
        font-size: 36px;
        color: #00ccbf;
      }

      .btn {
        font-size: 36px;
        color: #ffffff;
        text-align: center;
        line-height: 36px;
        width: 240px;
        margin-left: 20px;

        .van-button__text {
          font-size: 36px;
          color: #ffffff;
          text-align: center;
        }
      }
    }
  }
}
</style>
